import { Component, OnInit, Input, Output , EventEmitter, Inject, LOCALE_ID} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoModalComponent } from 'src/app/video-modal/video-modal.component';

@Component({
  selector: 'app-connection-step-c',
  templateUrl: './connection-step-c.component.html',
  styleUrls: ['./connection-step-c.component.scss']
})
export class ConnectionStepCComponent {
  @Input() error: string;
  @Input() applicationId: string;
  @Input() applicationName: string;
  @Output() verify = new EventEmitter<any>();
  consentLink = 'https://docs.microsoft.com/en-us/azure/active-directory/manage-apps/grant-admin-consent';

  constructor(
    private modalService: NgbModal,
    @Inject(LOCALE_ID) public locale: string,
  ) { }

  isEnglishLocale() {
    return !(typeof this.locale === 'string' && this.locale.toLowerCase().substring(0, 2) === 'pt');
  }

  tryVerify() {
    this.verify.emit();
  }

  async showModal(component: any, componentInputs?: Record<string, any>): Promise<boolean> {
    try {
      const modalRef = this.modalService.open(component, { ariaLabelledBy: 'modal' });
      // Set component instance inputs with parameter object key/value pairs
      if (componentInputs) {
        for (let property in componentInputs) {
          modalRef.componentInstance[property] = componentInputs[property];
        }
      }
      const result = await modalRef.result;
      return result;
    } catch(reason) {
      // Continue regardless of error
    }
    return null;
  }

  async onViewInstructionVideoClick() {
    const videoWidth = window.innerWidth * 0.8 | 0;
    await this.showModal(VideoModalComponent, {
      modalTitle: "Reportsfeed - Microsoft Azure",
      videoUrl: this.isEnglishLocale() ? "/assets/videos/ReportsFeed - Microsoft Azure EN.webm" : "/assets/videos/ReportsFeed - Microsoft Azure PT.webm",
      videoWidth
    });
  }

}
